import React from 'react';
import { Box, Typography } from '@mui/material';
import { Card } from '../../Library/Card';
import { CustomIcon } from '../../../atoms';
import { colors, theme } from '../../../utils/theme';

interface Symptom {
  icon: string;
  text: string;
}

interface SubOptimalSymptomsProps {
  title: string;
  symptoms: Symptom[];
}

export const SubOptimalSymptoms = ({
  details,
}: {
  details: SubOptimalSymptomsProps;
}): JSX.Element => {
  const { title, symptoms } = details;
  return (
    <Box>
      <Card
        title={title}
        content={
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            sx={{ mt: 3.5, mb: 1 }}
          >
            {symptoms?.map((symptom, index) => (
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
                key={`${symptom.text}-${index}`}
              >
                <Box display="flex" flexDirection="column" alignItems="center">
                  <CustomIcon
                    name={symptom.icon}
                    hex="black"
                    sx={{
                      width: 30,
                      height: 30,
                      fill: colors.greys.BASE_WHITE,
                      mb: 1,
                      [theme.breakpoints.down('sm')]: {
                        width: 28,
                        height: 28,
                      },
                    }}
                  />
                  <Box display="flex" flexDirection="column">
                    <Typography variant="light" fontSize={{ xs: 12, md: 16 }}>
                      {symptom.text}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        }
      />
    </Box>
  );
};
